import { QueryKey, useQuery, UseQueryOptions } from "react-query";
import { TRIP_ENDPOINT } from "./constants";
import useFetchWithAuth from "@/fetch/fetchWithAuth";
import { useCurrentTrip } from "@/hooks";

export type PlacementType = {
  id: number;
  tid: number;
  interview_id: number;
  type: string;
  name: string;
  status: string;
  start_date: number;
  end_date: number;
  comment: string;
  _ca: number;
  _cb: number;
  _lma: null;
  _lmb: null;
};

type TripPlacementResult = {
  success: boolean;
  result: Array<PlacementType>;
};
type QueryError = {};

const useTripPlacementsQuery = (
  options?: UseQueryOptions<
    TripPlacementResult,
    QueryError,
    TripPlacementResult,
    QueryKey
  >
) => {
  const { currentTrip } = useCurrentTrip();
  const tid = currentTrip?.id;
  const url = `${TRIP_ENDPOINT}/placement/trip/${tid}`;
  const { fetchWithAuth } = useFetchWithAuth();
  const cacheKey = [url];

  return useQuery<TripPlacementResult, QueryError>(
    cacheKey,
    async () => {
      if (!tid) throw new Error();
      const res = await fetchWithAuth<TripPlacementResult>(url);
      return res;
    },
    {
      enabled: !!tid,
      ...options,
    }
  );
};
export default useTripPlacementsQuery;
